// src/components/Profile/UserProfile.js
import React from 'react';
import { Container, Heading } from '../../styled/common';
import styled from 'styled-components';

const ProfileCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: ${({ theme }) => theme.padding};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.backgroundColor};
`;

const Detail = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.textFontSize};
  color: ${({ theme }) => theme.textColor};
  
  strong {
    color: #555;
  }
`;

const UserProfile = ({ user }) => {
  if (!user) return null;

  return (
    <Container>
      <ProfileCard>
        <Heading>{`${user.name}'s Profile`}</Heading>
        <Detail><strong>Name:</strong> {user.name}</Detail>
        <Detail><strong>Email:</strong> {user.email}</Detail>
        <Detail><strong>Role:</strong> {user.role.toUpperCase()}</Detail>
        <Detail><strong>State Location:</strong> {user.stateLocation}</Detail>
      </ProfileCard>
    </Container>
  );
};

export default UserProfile;
